import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";

const environment = process.env.REACT_APP_ENV;
const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_CSwQUSpnV4M-tH1m31PBwfbIE6cHhd8",
  authDomain: "fullproof-app.firebaseapp.com",
  projectId: "fullproof-app",
  storageBucket: "fullproof-app.firebasestorage.app",
  messagingSenderId: "700451320996",
  appId: "1:700451320996:web:2e95136981e1cb35462231",
  measurementId,
};

// Initialize Firebase
const dbName = process.env.REACT_APP_DB_NAME || '(default)';
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app, dbName);

if (process.env.REACT_APP_EMULATE_DB === "true") {
  connectFirestoreEmulator(db, 'localhost', 8080);
}

// Enable offline persistence
enableIndexedDbPersistence(db, {
  forceOwnership: false
}).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Persistence failed: Multiple tabs open');
  } else if (err.code === 'unimplemented') {
    console.warn('Persistence not available');
  }
});

const analytics = getAnalytics(app);

// Set the environment as a user property
if (analytics) {
  setUserProperties(analytics, { environment });
}

// Helper function to log events with debug_mode for staging
const logAnalyticsEvent = (eventName, params = {}) => {
  if (environment !== "production") {
    logEvent(analytics, eventName, { ...params, debug_mode: true });
  } else {
    logEvent(analytics, eventName, params);
  }
};

export { auth, db, app, analytics, logAnalyticsEvent };
